<template>
  <div v-if="enabled && rows.length" class="watermark-overlay" :style="overlayStyle">
    <div
      v-for="(row, index) in rows"
      :key="index"
      class="watermark-row"
      :style="rowStyle"
    >
      <span
        v-for="item in columnCount"
        :key="`${index}-${item}`"
        class="watermark-text"
        :style="textStyle"
      >
        {{ text }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "rgba(21,102,193,0.10)",
    },
    fontSize: {
      type: Number,
      default: 14,
    },
    rotate: {
      type: Number,
      default: -20,
    },
    gap: {
      type: Number,
      default: 120,
    },
  },
  data() {
    return {
      rowCount: 0,
      columnCount: 3,
    };
  },
  computed: {
    rows() {
      return Array.from({ length: this.rowCount }, (_, index) => index);
    },
    overlayStyle() {
      return {
        paddingTop: `${this.gap / 2}px`,
      };
    },
    rowStyle() {
      return {
        marginBottom: `${this.gap}px`,
        transform: `rotate(${this.rotate}deg)`,
      };
    },
    textStyle() {
      return {
        color: this.color,
        fontSize: `${this.fontSize}px`,
        marginRight: `${this.gap}px`,
      };
    },
  },
  mounted() {
    this.updateGrid();
    window.addEventListener("resize", this.updateGrid);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateGrid);
  },
  methods: {
    updateGrid() {
      const height = window.innerHeight || document.documentElement.clientHeight || 667;
      const width = window.innerWidth || document.documentElement.clientWidth || 375;
      this.rowCount = Math.max(6, Math.ceil(height / Math.max(this.gap, 80)) + 2);
      this.columnCount = Math.max(2, Math.ceil(width / Math.max(this.gap * 1.6, 160)) + 1);
    },
  },
};
</script>

<style lang="less" scoped>
.watermark-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.watermark-row {
  display: flex;
  white-space: nowrap;
}

.watermark-text {
  display: inline-block;
  line-height: 1.4;
  user-select: none;
}
</style>
